import { SyncEventType } from '../../enums/syncEventType';
import { PersistenceEvent } from './persistenceEvent';

export class EventIssueCreated implements PersistenceEvent {

  public readonly type = SyncEventType.ISSUE_CREATED;
  // The real issueId from the issuetracking-system
  public issueId: number;
  // The temporary issueId we used to identify the new issue before it was persisted to the issuetracking-system
  public temporaryIssueId: number;
  // If this event is for a subissue, this holds the id of the parent issue
  public parentIssueId: number;
  public isSubissue: boolean;

  constructor(issueId: number, temporaryIssueId: number, parentIssueId: number, isSubissue: boolean) {
    this.issueId = issueId;
    this.temporaryIssueId = temporaryIssueId;
    this.parentIssueId = parentIssueId;
    this.isSubissue = isSubissue;
  }

  getPayload(): object {
    const payload = {
      'issueId': this.issueId,
      'temporaryIssueId': this.temporaryIssueId,
      'parentIssueId': this.parentIssueId,
      'isSubissue': this.isSubissue
    };
    return payload;
  }

  static fromPayload(payload: any): EventIssueCreated {
    return new EventIssueCreated(
      payload['issueId'],
      payload['temporaryIssueId'],
      payload['parentIssueId'],
      payload['isSubissue']
    );
  }

}

